import React from "react";
import { useSelector } from "react-redux";
import styles from "./api-result.module.css";
import { getPortal } from "../../services/selectors";


const ApiResult = () => {

  const { title, text } = useSelector(getPortal);


  return (
    <>
      <h2 className={styles.title}>
        {title}
      </h2>
      <p className={styles.text}>
        {text}
      </p>
    </>
  )
}

export default ApiResult;
